import { Box } from "@mui/material";

const SectorDashboard = () => {
  return <Box>Sector Dashboard Not implemented</Box>;
};
export default SectorDashboard;
